import type { FormConfig } from '../types';
import aboutYou from '../pages/bedrock/aboutYou';
import trialRequest from '../pages/bedrock/trialRequest';

const formConfig: FormConfig = {
  live: true,
  id: 'bedrock',
  formName: 'LLM as a Service',
  title: 'LLM as a Service',
  subTitle: 'Summary page',
  showSections: true,
  sharing: false,
  requiredFlag: true,
  sections: [
    {
      title: 'Expression of interest',
      slug: 'expression-of-interest',
      subsections: [
        {
          title: 'About you',
          slug: 'about-you',
          pages: aboutYou,
        },
        {
          title: 'LLM request',
          slug: 'requirements',
          pages: trialRequest,
        },
      ],
    },
  ],
};

export default formConfig;
